import { render, staticRenderFns } from "./TagComponents.vue?vue&type=template&id=6aa0afd9&scoped=true&"
import script from "./TagComponents.vue?vue&type=script&lang=js&"
export * from "./TagComponents.vue?vue&type=script&lang=js&"
import style0 from "./TagComponents.vue?vue&type=style&index=0&id=6aa0afd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa0afd9",
  null
  
)

export default component.exports